<template>
    <div class="contact2">
        <p class="contactTitle">Contact</p>
        <img src="../assets/contactList.svg" class="list">
        <br />
        <button @click="toHome" class="naviItem">Home</button>
    </div>
    </template>
        
<style scoped>
.contact2 {
    overflow: scroll;
    background-image: url('../assets/Scontact2bg@1024x.png');
    background-size: cover;
    overflow: auto;
    text-align: center;
}



.contactTitle {
    font-family: brother-1816, sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 23pt;
    position: absolute;
    top: 57px;
    left: 39px;
}

.list {
    position: relative;
    top: 170px;
    width: 85vw;
    max-width: 500px;
    padding-bottom: 100px;
}

.naviItem {
    font-family: 'LeferiBaseType-RegularA';
    font-size: 11pt;
    text-decoration: underline;
    color: #0D00B4;
    position: relative;
    border: 0;
    background-color: transparent;
    margin-top: 150px;
    margin-bottom: 80px;
}

</style>
    
<script setup>
import { useRouter } from 'vue-router'
const router = useRouter()
router.beforeEach(function(to, from, next){
    if(from.path == '/contact2' && to.path == '/contact1') {
    to.meta.transition = 'slide-left'
    from.meta.transition = 'slide'
    }
    else {
    to.meta.transition = 'slide'
    }
    window.removeEventListener("touchstart",startevent);
    window.removeEventListener("touchend", endevent);
    next();
});

function startevent(event) {
    if(event.touches.length === 1){
    start = event.touches.item(0).clientX;
    }else{
    start = null;
    }
}

function endevent(event) {
    var offset = 100;
    if(start){
    var end = event.changedTouches.item(0).clientX;
    if(end > start + offset){
        router.push('/contact1');
    }
    else if(end < start - offset ){
        router.push('/');
    }
    }
}

function toHome() {
    router.push('/');
}

var start = null;
window.addEventListener("touchstart",startevent);
window.addEventListener("touchend", endevent);
</script>